<template>
    <div class="form-content ve-list" v-show="item.visible">
        <!--<el-row :gutter="20">-->
            <!--<el-col :span="12">-->
                <!--<div class="item-list-title">-->
                    <!--{{ item.label }}-->
                    <!--<el-tooltip class="item" effect="dark" placement="top-start" v-if="item.description">-->
                        <!--<div slot="content">-->
                            <!--{{item.description}}-->
                        <!--</div>-->
                        <!--<img class="" style="position: relative; width: 19px;top: 4px;left: 4px;" :src="require('@/assets/question.png')"/>-->
                    <!--</el-tooltip>-->
                <!--</div>-->
            <!--</el-col>-->
        <!--</el-row>-->
        <!-- {{emptyKeys()}} -->
        <span class="ve-list-widget label">{{localized(`label`)}}</span>
        <el-button style="position: absolute;top: -50px;right: 0px;"
                       type="text"
                       @click="addListItem"
                       :style="{opacity: itemdata.length === item.max ? .5 : 1}"
                       :disabled="itemdata.length === item.max || disabled">
                <img src="@/assets/add.png"
                     style="position: relative;z-index: 1001"
                     :style="{opacity: disabled ? '.5' : 1}"
                     width="30px" />
            </el-button>
        <div class="ve-list-border">
            <div v-for="(li, idx) in itemdata" :label="item.label + '_' + idx" :key="li.key">
            <div class="delete-container">
              <div class="horizontal-line" v-show="idx > 0"></div>
                <el-button style="margin-right: 0px;"
                       type="text"
                       v-show="idx > 0"
                       :disabled="item.minLength === itemdata.length || disabled"
                       @click="removeListItem(idx)">
                <img src="@/assets/delete.png"
                     style="position: relative;z-index: 1001"
                     :style="{opacity: disabled ? '.5' : 1}"
                     width="30px" />
              </el-button>
            </div>
            <el-form :model="itemdata[idx]" :ref="`form[${item.uuid}/${idx}]`" label-position="left">
                <form-items v-model="itemdata[idx]" :items="item.content" :deep="deep+1" :editable="editable" :index="idx" :editStatus='editStatus'/>
            </el-form>
        </div>
        </div>
    </div>

</template>

<script>
import { mapGetters } from 'vuex'
import FormItems from '../FormItems'
import utils from '../../utils'
import language from '@/lang'

export default {
	name: 'list-widget',
  data() {
		return {
      copyitem: {}
    }
  },
	props: {
		editable: { type: Boolean },
		item: Object,
		value: Array,
    deep: Number,
    editStatus: { type: String }
	},
	components: { FormItems },
	beforeDestroy() {
		// alert('destroy')
	},
	methods: {
		addListItem() {
			this.itemdata.push(this.deepClone(this.copyitem))
      this.$nextTick(() => {
				let result = this.$store.getters.getFormSet.slice().filter(item => item !== undefined)
				let name = `form[${this.item.uuid}/${this.itemdata.length - 1}]`
				this.$refs[name] && result.push(this.$refs[name][0])
				this.$store.dispatch('setFormSet', result)
      })
		},
		removeListItem(idx) {
			this.itemdata.splice(idx, 1)
			let result = this.$store.getters.getFormSet.slice().filter(item => item !== undefined)
			let name = `form[${this.item.uuid}/${idx}]`
      let delIndex
			result.forEach((form, index) => {
				if (form === name) {
					delIndex = index
        }
      })

			result.splice(delIndex, 1)
			this.$store.dispatch('setFormSet', result)
		},
		deepClone(obj) {
			let result = Array.isArray(obj) ? [] : {}
			for (let key in obj) {
				if (obj.hasOwnProperty(key)) {
					if (typeof obj[key] === 'object') {
						result[key] = this.deepClone(obj[key]) //递归复制
					} else {
						result[key] = ''
					}
				}
			}
			return result;
    },
    localized(key){
      return language.localize(this.$store.state,this.item.name, key, this.item[key])
    },
	},
	computed: {
		...mapGetters({
			formStatus: 'getFormStatus',
			softDataStatus: 'getSoftDataStatus'
		}),
		disabled() {
			return this.softDataStatus === 'disable'
		},
		itemdata: {
			get() { return this.value },
			set(itemdata) {
        this.$emit('input', 
            itemdata 
        ) }
		}
  },
  mounted() {
    
    if (!this.itemdata) {
      return
    }
    var deepObject = (this.itemdata && this.itemdata[0]) || utils.initKeys(this.item.content, {})
    if(!(this.itemdata instanceof Array) || this.itemdata == undefined) {
      return
    }
    if((this.itemdata instanceof Array) &&  (this.itemdata && this.itemdata.length <= 0)){
      this.itemdata.push(utils.initKeys(this.item.content, {}))
    }

		this.copyitem = this.deepClone(deepObject)
    this.copyitem.label = ""
		let result = this.$store.getters.getFormSet.slice().filter(item => item !== undefined)
		let name = `form[${this.item.uuid}/${this.itemdata.length - 1}]`
		this.$refs[name] && result.push(this.$refs[name][0])
		this.$store.dispatch('setFormSet', result)
		setTimeout(() => {
			if (this.item.minLength > 0) {
				for (let i = 0; i < this.item.minLength; i++) {
					this.itemdata.push(utils.initKeys(this.item.content, {}))
					this.$nextTick(() => {
						let result = this.$store.getters.getFormSet.slice().filter(item => item !== undefined)
						let name = `form[${this.item.uuid}/${this.itemdata.length - 1}]`
						this.$refs[name] && result.push(this.$refs[name][0])
            this.$store.dispatch('setFormSet', result)
            // this.filterData()
					})
				}
			}
    }, 300)
  }

}
</script>

<style scoped>
  .item-list-title {
      padding-top: 5px;
  }
  .ve-list > div {
    position: relative;
    margin-top: 50px;
  }
    .ve-list-widget.label {

        position: absolute;
        display: inline-block;

        text-align: left;

        top: -40px;
        left: 0px;

        font-weight: 600;
        color: #000000;
        line-height: 32px;

        vertical-align: middle;
        font-size: 14px;
        box-sizing: border-box;
    }

    .ve-list-border {
      border: 1px solid #ccc;
      border-radius: 3px;
      padding: 10px;
    }
    .delete-container {
      width: 100%;
      text-align: right;
      display: flex;
      justify-content: space-between;
      flex-direction: row;
    }

    .horizontal-line {
        width: calc(100% - 40px);
        height: 1px;
        margin-top: 26px;
        border-bottom: 1px dashed #ccc;
      }


</style>
